import { faChevronDown, faMessages } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Typography } from 'components/common'
import FieldLabel from 'components/common/FieldLabel'
import Comment, { TCommentType } from './Comment'
import CommentInput from './CommentInput'
import {
  ThreadQueryResult,
  useCommentAddedSubscription
} from 'graphql/generated'
import useThreadComments from './useThreadComments'
import InfiniteList from 'components/InfiniteList'

const ThreadComments: React.FC<{ thread: ThreadQueryResult['thread'] }> = ({
  thread
}) => {
  const {
    comments,
    loading: loadingComments,
    loadMoreComments,
    loadingMore: loadingMoreComments,
    refetch: refetchComments
  } = useThreadComments(thread.id)

  useCommentAddedSubscription({
    variables: { threadId: thread.id },
    onData: () => {
      refetchComments()
    }
  })

  return (
    <div className="flex flex-col gap-6 pb-4">
      <div>
        <FieldLabel label="Comment" />
        <CommentInput
          parentId={thread.id}
          onSave={() => {
            refetchComments()
          }}
          type="Comment"
        />
      </div>

      <div>
        <Typography size="sm" color="blue">
          {thread.replyCount} Comments <FontAwesomeIcon icon={faChevronDown} />
        </Typography>

        <InfiniteList<TCommentType>
          className="relative overflow-visible space-y-2 mt-2"
          loading={loadingComments}
          loadingMore={loadingMoreComments}
          loadMore={loadMoreComments}
          items={comments}
          renderItem={comment => {
            return (
              <Comment
                parentId={thread.id}
                key={comment.id}
                onDelete={() => {
                  refetchComments()
                }}
                comment={comment}
                wrapperClassName="border border-gray-200 rounded-md"
              />
            )
          }}
          emptyText={
            <div className="mt-4 flex flex-col gap-4 items-center justify-center">
              <FontAwesomeIcon
                icon={faMessages}
                size="5x"
                className="text-gray-300"
              />
              <Typography color="lightGray">{`Looks like there's no comment's yet, be the first by commenting above!`}</Typography>
            </div>
          }
        />
      </div>
    </div>
  )
}

export default ThreadComments
